import api from '../index';

const fetchStackingPlan = (id: string) => {
    return api.get(`/propertyassetstackingplan/${id}`);
};

const PropertyAssetStackingPlanApi = { fetchStackingPlan };
export default PropertyAssetStackingPlanApi;
